const KEYS = {
  email: 'registration_email',
  fullName: 'registration_full_name',
  verificationToken: 'registration_verification_token',
  success: 'registration_success',
};

export function setRegistrationDraft({ email, fullName }) {
  if (email) sessionStorage.setItem(KEYS.email, email);
  if (fullName) sessionStorage.setItem(KEYS.fullName, fullName);
}

export function getRegistrationEmail() {
  return sessionStorage.getItem(KEYS.email) || '';
}

export function getRegistrationFullName() {
  return sessionStorage.getItem(KEYS.fullName) || '';
}

export function setVerificationToken(token) {
  if (token) sessionStorage.setItem(KEYS.verificationToken, token);
}

export function getVerificationToken() {
  return sessionStorage.getItem(KEYS.verificationToken) || '';
}

export function hasRegistrationEmail() {
  return Boolean(getRegistrationEmail());
}

export function hasVerifiedRegistration() {
  return Boolean(getVerificationToken());
}

export function setRegistrationSuccess(data) {
  sessionStorage.setItem(KEYS.success, JSON.stringify(data));
}

export function getRegistrationSuccess() {
  try {
    const raw = sessionStorage.getItem(KEYS.success);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearRegistrationSession() {
  Object.values(KEYS).forEach((key) => sessionStorage.removeItem(key));
}
